require('./folderPlaylist.styles');
const template = require('./folderPlaylist.template');

export function FolderPlaylistDirective(
		$interval:ng.IIntervalService, 
		$timeout:ng.ITimeoutService,
		$mdMedia):ng.IDirective {
	return {
		restrict: 'E',
		controller: FolderPlaylistController,
		controllerAs: 'vm',
		template,
		bindToController: true,
		scope: {
			content: '='
		},
		link: (scope, element, attrs, vm:FolderPlaylistController)=>{
			
			//add event for ended
			let mediaElm:HTMLMediaElement;
			function setMediaEndEvents(){
				mediaElm = null;
				let i = $interval(()=>{
					if(vm.activeMedia.FileFormat === 'Video'){
						mediaElm = <HTMLMediaElement>element[0].querySelector('.sb-media-viewer__video-player');
					}
					else if(vm.activeMedia.FileFormat === 'Audio File'){
						mediaElm = <HTMLMediaElement>element[0].querySelector('.sb-media-viewer__audio-player');
					}

					if(mediaElm){
						$interval.cancel(i);
						angular.element(mediaElm).on('ended',(ev)=>{
							scope.$apply(()=>{								
								vm.mediaEnded();
							});
						});
					}

				},50);
				
				if($mdMedia('xs')){return;}
				scrollToActive();
			}

			let queueScroller:HTMLElement;
			function scrollToActive(){				
				$timeout(()=>{
					if(!queueScroller){
						queueScroller = <HTMLElement>element[0].querySelector('.sba-folder-playlist__queue-items');
					}

					let activeItem = <HTMLElement>queueScroller.querySelector('.sba-folder-playlist__active-item');
					if(activeItem){
						queueScroller.scroll({top:activeItem.offsetTop - 70, behavior:'smooth'});
					}

				},800);

			}

			scope.$watch('vm.activeMedia',(newVal, oldVal)=>{
				if(!newVal && newVal===oldVal){return;}

				setMediaEndEvents();
			});
		}
	}
}

FolderPlaylistDirective.$inject = [
	'$interval',
	'$timeout',
	'$mdMedia'
];

export class FolderPlaylistController implements ng.IComponentController {
	public static $inject = [
		'$timeout',
		'pxAuthService',
		'$mdMedia'
	];

	constructor( 
		private readonly $timeout:ng.ITimeoutService,
		private readonly authService,
		private readonly $mdMedia
	) {	
		this.activeMedia =  this.content[0];

		//TODO - toolbar stuff
	}

	public content;
	public activeMedia;
	public autoplay:Boolean = true;
	public firstMediaEnded:Boolean = false;
	public addMediaEndedEvent:Function;
	public get autoplayNext():Boolean{ return this.autoplay && this.firstMediaEnded};

	public mediaEnded(){
		if(this.autoplay){
			let timeout = this.activeMedia.FileFormat === 'Audio File' ? 0 : 3000;
			this.$timeout(()=>{				
				this.firstMediaEnded = true;
				let currentIndex = this.content.indexOf(this.activeMedia);
				this.content[currentIndex].played = true;
				if(currentIndex < this.content.length-1){
					this.activeMedia = this.content[currentIndex+1];
				}
			}, timeout);
			
		}

	}

	public $onChanges(changes:ng.IOnChangesObject){
		
	}
	public $onInit(){

	}
	public $onDestroy(){
			
	}
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/folderPlaylist/folderPlaylist.ts